import { render } from "./ApiGuideCampaignForm.vue?vue&type=template&id=67fc16ae&scoped=true"
import script from "./ApiGuideCampaignForm.vue?vue&type=script&lang=js"
export * from "./ApiGuideCampaignForm.vue?vue&type=script&lang=js"

import "./ApiGuideCampaignForm.vue?vue&type=style&index=0&id=67fc16ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fc16ae"]])

export default __exports__